import { STOP_LOADING, START_LOADING } from "./Types/loader";
import { LOGOUT_SUCCESS, MODIFY_TOKEN, SHOW_TOAST, STOP_TOAST } from "./Types/auth";
import { getIdToken } from "../firebase";
// import store from "./index";

const REACT_APP_API_BASE_URL_PATH = process.env.REACT_APP_API_BASE_URL_PATH || "/b2c/api";
// export const URL = (process.env.REACT_APP_API_BASE_URL || "") + REACT_APP_API_BASE_URL_PATH;
// const REACT_APP_API_BASE_OTHER_URL_PATH =
//   process.env.REACT_APP_API_BASE_OTHER_URL_PATH || "/axuat/api2";
// (process.env.REACT_APP_API_BASE_OTHER_URL || "") + REACT_APP_API_BASE_OTHER_URL_PATH;
// export const SECONDARY_BASE_URL_PATH = "https://app.autorox.co:9443/axuat"; //process.env.SECONDARY_URL || "/ROOT";

//PROD
export const URL = "https://tserv-app.autorox.co/api";
export const OTHER_BASE_URL = "https://app.autorox.co/api2";
export const SECONDARY_BASE_URL = "https://app.autorox.co"; //(process.env.REACT_APP_API_BASE_OTHER_URL || "") + SECONDARY_BASE_URL_PATH;

//UAT
// export const URL = "https://new-test.autorox.co:8093/b2c/api";
// export const OTHER_BASE_URL = "https://app.autorox.co:9443/axuat/api2";
// export const SECONDARY_BASE_URL = "https://app.autorox.co:9443/axuat"; //(process.env.REACT_APP_API_BASE_OTHER_URL || "") + SECONDARY_BASE_URL_PATH;

export const DEFAULT_HEADERS = {
	Accept: "application/json",
	"Content-Type": "application/json",
};

const FORM_HEADERS = {
	// Accept: "application/json",
	// "Content-Type": "multipart/form-data",
};

class AuthError extends Error {}

async function invokeAPI(
	endpoint,
	token,
	config,
	{ isForm = false },
	headerContent = {},
	check = {},
	extension = "",
	fileName = "download",
	next,
	successType,
	additionalData,
	showLoader = false,
	otherUrl = false,
	secondaryUrl = false,
	showToast = false,
	toastMessage = ""
) {
	// console.log(
	//   "process.env.REACT_APP_API_BASE_OTHER_URL_PATH  ==",
	//   process.env.REACT_APP_API_BASE_OTHER_URL_PATH,
	// );
	// console.log("process.env.REACT_APP_API_BASE_URL  ==", process.env.REACT_APP_API_BASE_URL);
	// console.log("REACT_APP_API_BASE_URL_PATH ==", REACT_APP_API_BASE_URL_PATH);
	// console.log("OTHER_BASE_URL ==", OTHER_BASE_URL);
	// console.log("URL ==", URL);

	const default_headers = isForm ? FORM_HEADERS : DEFAULT_HEADERS;
	let headers;
	if (endpoint.toLowerCase() === "/reservations") {
		headers = token
			? { ...default_headers, ...headerContent }
			: { ...default_headers, ...headerContent };
	} else {
		headers = token
			? {
					...default_headers,
					Authorization: `Bearer ${token}`,
					...headerContent,
			  }
			: { ...default_headers, ...headerContent };
	}
	const updatedConfig = { ...config, headers };
	if (window.cordova) {
		window.cordova.plugin.http.setDataSerializer(isForm ? "multipart" : "json");
	}

	var response;
	if (window.cordova) {
		let finalURL = otherUrl ? OTHER_BASE_URL + endpoint : URL + endpoint;
		if (secondaryUrl) {
			finalURL = SECONDARY_BASE_URL + endpoint;
			// console.log("SBURL === ", finalURL);
		}
		// console.log("Fetch URL ======" + finalURL);
		await new Promise((resolve, reject) => {
			window.cordova.plugin.http.sendRequest(
				finalURL,
				updatedConfig,
				function (responseSucc) {
					const parsedBody = JSON.parse(responseSucc.data);
					if (Object.keys(parsedBody)) {
						const res = parsedBody;
						if (res.status === "SUCCESS") {
							if (showToast && toastMessage) {
								next({
									type: SHOW_TOAST,
									message: toastMessage,
									severity: "success",
								});
								setTimeout(() => {
									next({ type: STOP_TOAST });
								}, 4000);
							}
						}
						successType &&
							next({
								body: {
									...parsedBody,
									location: responseSucc.headers.location,
								},
								type: successType,
								additionalData,
							});
						response = {
							...parsedBody,
							location: responseSucc.headers.location,
						};
						resolve({
							...parsedBody,
							location: responseSucc.headers.location,
						});
					}
				},
				function (responseFail) {
					const res = JSON.parse(responseFail.error);
					response = res;
					if (res.status === "404 NOT_FOUND") {
						const { title } = res.error;
						if (title === "No user found with this referral code") {
							next({
								type: SHOW_TOAST,
								message: title,
								severity: "warning",
							});
							setTimeout(() => {
								next({ type: STOP_TOAST });
							}, 4000);
						}
					}
					if (res.status === "409 CONFLICT") {
						const showError = additionalData.hasOwnProperty("showError")
							? additionalData.showError
							: true;
						const { title } = res.error;
						if (showError) {
							next({
								type: SHOW_TOAST,
								message: title,
								severity: "warning",
							});
							setTimeout(() => {
								next({ type: STOP_TOAST });
							}, 4000);
						}
					}
					if (res.status === "500 INTERNAL_SERVER_ERROR") {
						const { error } = res;
						next({
							type: SHOW_TOAST,
							message:
								error &&
								error.details &&
								error.details.length &&
								(error.details[0] || "").includes("Maximum upload size exceeded")
									? "Maximum upload size exceeded"
									: "500, Something went wrong ..." + res.message,
							severity: "warning",
						});
						setTimeout(() => {
							next({ type: STOP_TOAST });
						}, 4000);
					}
					if (showLoader) {
						next({ type: STOP_LOADING });
					}
				}
			);
		});
	} else {
		let finalURL = otherUrl ? OTHER_BASE_URL + endpoint : URL + endpoint;
		if (secondaryUrl) {
			finalURL = SECONDARY_BASE_URL + endpoint;
		}
		// console.log("Calling API = " + finalURL);
		const resp1 = await fetch(finalURL, updatedConfig);
		const resp2 = await resp1.json();
		response = { ...resp2, location: resp1.headers.get("location") };
	}
	if (response.status === 401) {
		const { __globals = [], code, ...errors } = response;
		// throw new Error(code);
		throw new AuthError(code);
	}
	if (response.status >= 500) {
		// throw new Error("Something went wrong");
		return {
			isError: true,
			errorMessage: `Error 500, Something Went Wrong ` + response.message,
		};
	}
	if (
		response.status === "404 NOT_FOUND" ||
		response.status === "500 INTERNAL_SERVER_ERROR" ||
		response.status === "400 BAD_REQUEST"
	) {
		const { __globals = [], message, ...errors } = response;
		//TODO: Fix this error so we can send errors from API directly.
		const [firstError] = [...Object.values(errors)];
		// throw new Error(firstError || "Something went wrong");
		return {
			isError: true,
			errorMessage:
				!!errors &&
				errors.error &&
				errors.error.details &&
				errors.error.details.length &&
				(errors.error.details[0] || "").includes("Maximum upload size exceeded")
					? "Maximum upload size exceeded"
					: message || "Something went wrong",
			showError: additionalData.hasOwnProperty("showError")
				? additionalData.showError
				: true,
		};
	}
	if (response.status === "409 CONFLICT") {
		const { title } = response.error;
		return {
			isError: true,
			errorMessage: title || "409, Something went wrong ..." + response.message,
			showError: additionalData.hasOwnProperty("showError")
				? additionalData.showError
				: true,
		};
	}
	return response;
}

export const CALL_API = "Call API";
const middleware = (store) => (next) => async (action) => {
	if (typeof action[CALL_API] === "undefined") {
		return next(action);
	}
	let {
		url,
		method,
		types = [],
		showLoader = false,
		otherUrl = false,
		secondaryUrl = false, // false for prod --- true for UAT
		body = undefined,
		params,
		showToast = false,
		toastMessage = "",
		isForm = false,
		headerContent = {},
		check = {},
		extension = "",
		fileName = "download",
		additionalData = {},
	} = action[CALL_API];
	const [requestType, successType] = types;
	const { auth } = store.getState();
	requestType && next({ type: requestType });
	try {
		if (auth.token) {
			const access_token_info = JSON.parse(atob(auth.token.split(".")[1]));
			const expiry_time = new Date(access_token_info.exp * 1000);
			if (access_token_info.exp * 1000 < new Date().getTime()) {
				var idToken = await getIdToken(true);
				if (idToken) await next({ type: MODIFY_TOKEN, data: { token: idToken } });
			}
			if (showLoader) {
				next({ type: START_LOADING });
				//TODO: Dispatch show modal loader now.
			}
			const queryParams = new URLSearchParams();
			for (let param in params) {
				if (params[param]) {
					queryParams.set(param, params[param]);
				}
			}
			if (!(expiry_time < new Date()) || idToken) {
				const responseBody = await invokeAPI(
					url + (params ? "?" + queryParams.toString() : ""),
					expiry_time < new Date() ? idToken : auth.token,
					{
						method,
						[`${window.cordova ? "data" : "body"}`]: isForm
							? body
							: window.cordova
							? body
							: JSON.stringify(body),
					},
					{ isForm },
					headerContent,
					check,
					extension,
					fileName,
					next,
					successType,
					additionalData,
					showLoader,
					otherUrl,
					secondaryUrl,
					showToast,
					toastMessage
				);
				if (!window.cordova) {
					if (!responseBody.file) {
						if ((responseBody || {}).isError && (responseBody || {}).showError) {
							next({ type: SHOW_TOAST, message: responseBody.errorMessage });
							setTimeout(() => {
								next({ type: STOP_TOAST });
							}, 4000);
							return;
						}
						if (check["Content-Type"] === "text/csv" && check["shouldDisplayMessage"]) {
							next({
								type: SHOW_TOAST,
								message: responseBody.message,
								severity: "success",
							});
							setTimeout(() => {
								next({ type: STOP_TOAST });
							}, 4000);
							return;
						}
						if (showToast && toastMessage) {
							next({
								type: SHOW_TOAST,
								message: toastMessage,
								severity: "success",
							});
							setTimeout(() => {
								next({ type: STOP_TOAST });
							}, 4000);
						}
						successType &&
							next({
								body: { ...responseBody },
								type: successType,
								additionalData,
							});
					}
				}
				return responseBody;
			}
		}
	} catch (error) {
		if (error instanceof AuthError) {
			next({ type: SHOW_TOAST, message: `Please login to continue` });
			setTimeout(() => {
				next({ type: STOP_TOAST });
			}, 3000);
			next({ type: LOGOUT_SUCCESS });
		} else {
			throw error.message;
		}
	} finally {
		if (showLoader) {
			next({ type: STOP_LOADING });
			//TODO: Dispatch hide modal loader now.
		}
	}
};
export default middleware;
